import React, { useState } from "react";
import MUIDataTable from "mui-datatables";
import { Select, MenuItem } from "@material-ui/core";

const tShirtSizes = ["", "XS", "S", "M", "L", "XL", "XXL"]; // Options pour le menu déroulant

const TableGroupe = ({ rowData }) => {
    const [sizes, setSizes] = useState(rowData.map(person => person.Lien_11.Taille_Tshirt));

    const handleChange = (event, index) => {
        const newSize = event.target.value; // Nouvelle taille sélectionnée
        const newSizes = [...sizes]; // Copie des tailles actuelles
        newSizes[index] = newSize; // Mettre à jour la taille pour la personne en cours de traitement
        setSizes(newSizes); // Mettre à jour les tailles
    };
    const transformData = (rowData) => {
        return rowData.map(person => ({
            Nom: person.Lien_11.Name || "",
            Prenom: person.Lien_11.Firstname || "",
            Date_de_naissance: person.Lien_11.Birth || "", // Ajout de la colonne Date de naissance
            Sexe: person.Lien_11.Gender || "", // Ajout de la colonne Sexe
            Telephone: person.Lien_11.Phone_Mobile || "", // Ajout de la colonne Téléphone
            Email: person.Lien_11.Email || "", // Ajout de la colonne Email
            Tshirt: person.Lien_11.Taille_Tshirt || "", // Ajout de la colonne Tshirt
            // Ajoutez d'autres colonnes comme nécessaire
        }));
    };

    const columns = [
        {
            name: "Nom",
            label: "Nom",
        },
        {
            name: "Prenom",
            label: "Prénom",
        },
        {
            name: "Date_de_naissance",
            label: "Date de naissance",
        },
        {
            name: "Sexe",
            label: "Sexe",
        },
        {
            name: "Telephone",
            label: "Téléphone",
        },
        {
            name: "Email",
            label: "Email",
        },
        {
            name: "Tshirt",
            label: "T-shirt",
            options: {
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <Select value={sizes[dataIndex]} onChange={(event) => handleChange(event, dataIndex)}>
                            {tShirtSizes.map((size, sizeIndex) => (
                                <MenuItem key={sizeIndex} value={size}>{size}</MenuItem>
                            ))}
                        </Select>
                    );
                },
            },
        },
    ];

    const options = {
        search: true,  // Désactive l'icône de recherche
        filter: false,  // Désactive l'icône de filtre
        download: false,  // Désactive l'icône de téléchargement/export
        print: false,  // Désactive l'icône d'impression
        viewColumns: false,  // Désactive l'icône de vue des colonnes
        selectableRowsHeader: false,  // Désactive la case à cocher de sélection globale
        selectableRowsHideCheckboxes: true,  // Cache les cases à cocher de sélection individuelles
        selectableRows: 'none',
        sort: false,
    };


    return (
        <div style={{ width: '100%' }}>
            <MUIDataTable
                title={""}
                data={transformData(rowData)}
                columns={columns}
                options={options}
                style={{ width: '100%' }}
            />
        </div>
    );
};

export default TableGroupe;
